import { Button, CenterAlignedLoader, Drawer } from '@medly-components/core';
import styled from 'styled-components';

const drawerMobileTopPosition = '16.9rem';

export const Container = styled.div`
    display: flex;
    #medly-drawer-overlay,
    #medly-drawer {
        position: initial;

        @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
            position: fixed;
        }
    }
`;

export const DrawerWrapper = styled(Drawer)`
    #medly-drawer {
        height: 100%;
    }
    #medly-drawer-close-icon {
        height: 1.6rem;
        width: 1.6rem;
        top: 2.4rem;
        right: 2.4rem;
        border: 0.1rem solid ${({ theme }) => theme.colors.grey[400]};
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        @keyframes drawerSlideIn {
            0% {
                top: 100%;
            }

            100% {
                top: ${drawerMobileTopPosition};
            }
        }

        @keyframes drawerSlideOut {
            0% {
                top: ${drawerMobileTopPosition};
            }

            100% {
                top: 100%;
            }
        }

        #medly-drawer {
            border-radius: 1.6rem 1.6rem 0 0;
            top: ${drawerMobileTopPosition};
            height: calc(100% - ${drawerMobileTopPosition});
            overflow: auto;
        }
    }

    .matched-word {
        color: white;
        border: 0.1rem solid ${({ theme }) => theme.colors.royalBlue[200]};
        padding: 0 0.3rem;
        background: ${({ theme }) => theme.colors.royalBlue[500]};
    }
`;

export const Content = styled(Drawer.Content)`
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    overflow-x: hidden;
    row-gap: 3.2rem;
    flex: 1;
    padding: 3.2rem 2.4rem 2.8rem;
`;

export const Footer = styled(Drawer.Footer)`
    padding: 1.2rem 2.4rem;
    display: flex;
    gap: 2rem;

    ${Button.Style} {
        margin-left: 0;
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        flex-direction: column;
        ${Button.Style} {
            gap: 2rem;
        }
    }
`;

export const Loader = styled(CenterAlignedLoader)`
    position: fixed;
    top: 0;
    left: 0;
    cursor: progress;
    background: rgba(67, 84, 101, 0.5);
`;

export const DrawerDeskTopWrapper = styled(DrawerWrapper)`
    display: flex;
    width: 54rem;
    flex-direction: column;
`;
